<template>
  <v-data-table
    fixed-header
    :height="tableHeight"
    :headers="getHeaderList"
    :items="modelList"
    :options.sync="options"
    :loading="loading"
    :server-items-length="pagination.total"
    :footer-props="footerProps"
    class="elevation-1"
  />
</template>
<script>
import ApiMixin from '@/mixins/api-mixin'


import ListMixin from '@/mixins/list-mixin.vue'
import WorkerListMixin from '@/mixins/worker-list-mixin'

export default {
  name: 'WbdWorkerList',
  components: {
  },
  mixins: [ListMixin, ApiMixin, WorkerListMixin],
  data: () => ({
    loading: true,
    options: {},
    modelList: [],
    pagination: { total: 0 },
  }),
  computed: {

  },
  watch: {
    options: {
      handler () {
        this.getWorkerList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async  created () {
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[0],
    }
  },
  methods: {
    async getWorkerList (params) {
      await this.requestWorkerList(this.setModelRequestResult, {})
    },
    setModelRequestResult (requestResult) {
      if (requestResult && requestResult.error) {
        this.modelList = []
        this.loading = false
      } else {
        this.modelList = requestResult.modelList
        this.pagination = requestResult.total
        this.loading = false
      }
    },
  }
}
</script>

